import request from "../../../utils/request";

export const getExternalDealers = '/external-customer/page';


export function updateExternalDealer(params:any){
    return request.request({
        url: params?.id?'/external-customer/update':'/external-customer/add',
        method: "post",
        data: params
    });
}

export function deleteExternalDealer(id:string) {
    return request.delete(`/external-customer/delete/${id}`);
}

export function importExternalDealers(file:File, sysName:string="美年"){
    debugger
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sysName', sysName);
    return request.post('/external-customer/importExcel', formData);
}